import { cloneDeep } from "lodash";

const state = {
    generalFilter: null
};

const mutations = {
    APPLY_GENERAL_FILTER: (state, data) => {
        state.generalFilter = data;
    },
};

const actions = {
    async applyGeneralFilter({ commit }, data) {
        // commit('APPLY_GENERAL_FILTER', JSON.parse(JSON.stringify(data))) 
        commit("APPLY_GENERAL_FILTER", cloneDeep(data)); 
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};




// WEBPACK FOOTER //
// ./src/vuex/modules/general_filter.js